export const getCacheKey = (args: unknown, resourceType: string) =>
  JSON.stringify({ args, resourceType });
